module.exports = __webpack_public_path__ + "img/title-3.9b62c44f.png";